<select
  class="filter-dropdown"
  [class.filter-dropdown--active]="!!value()"
  [disabled]="disabled()"
  [value]="value()"
  [attr.aria-label]="placeholder()"
  [attr.data-testid]="testId()"
  (change)="onChange($any($event.target).value)"
>
  <option value="" [selected]="value() === ''">{{ placeholder() }}</option>
  @for (opt of options(); track opt.value) {
    <option [value]="opt.value" [disabled]="opt.disabled" [selected]="opt.value === value()">
      {{ opt.label }}
    </option>
  }
</select>
